import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/advice.vue'
wx.createPage(MiniProgramPage)